import React from 'react'
import { FieldError, UseFormRegisterReturn } from 'react-hook-form'

type MwSelectProps = {
  register: UseFormRegisterReturn
  error?: FieldError
  list: string[]
}

const MwSelect: React.FC<MwSelectProps> = ({ register, error, list }) => {
  return (
    <>
      <select className={`w-full ${error && 'contactSubmitError'} inline-block`} {...register}>
        <option value={''}>選択してください</option>
        {list.map((cc) => (
          <option key={cc} value={cc}>
            {cc}
          </option>
        ))}
      </select>
      {error && <p className="contactSubmitErrorMessage">{error.message}</p>}
    </>
  )
}

export default MwSelect
